import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $signInTrueIdFormTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('sign_in_with'),
}))
